// extracted by mini-css-extract-plugin
export default {"Radio":"ReviewMenu-module__Radio__wn1BeGn","RadioGroup":"ReviewMenu-module__RadioGroup__Fe6qr08","RadioText":"ReviewMenu-module__RadioText__FSu_6JO"};